/**
 * Creates a setTimeout implementation using requestAnimationFrame
 * @param {Function} callback - Function to execute
 * @param {number} delay - Delay in milliseconds
 * @returns {number} - ID that can be used to cancel the timeout
 */
export function setRAFTimeout(callback: () => void, delay: number) {
  const start = performance.now();

  let rafId;

  function checkTime(timestamp: number) {
    const elapsed = timestamp - start;

    if (elapsed >= delay) {
      callback();
    } else {
      rafId = requestAnimationFrame(checkTime);
    }
  }

  rafId = requestAnimationFrame(checkTime);

  return rafId;
}
